module.exports = __webpack_public_path__ + "img/20_104.ba180813.png";